// Vendor Libs
import React from 'react';

// Components
import FlexDashboard from '../core/flex-dashboard';
import UnmappedExternalNetworks from '../search-data/unmapped-external-networks';
import MapExternalNetworks from '../search-data/map-external-networks';
import CreateExternalNetwork from '../search-data/create-external-network';

// Configs
import getDashboardConfig from '../../../config/flex-dashboard-config';

const dashboardConfig = {
    layout: {
        type: 'row',
        children: [
            {
                type: 'tabset',
                children: [
                    {
                        type: 'tab',
                        name: 'Unmapped External Networks',
                        component: UnmappedExternalNetworks,
                    },
                ],
            },
            {
                type: 'tabset',
                children: [
                    {
                        type: 'tab',
                        name: 'Map External Network',
                        component: MapExternalNetworks,
                        config: {
                            componentProps: {},
                        },
                    },
                    {
                        type: 'tab',
                        name: 'Create External Network',
                        component: CreateExternalNetwork,
                        config: {
                            componentProps: {},
                        },
                    },
                ],
            },
        ],
    },
};

function DashboardMapExternalNetworks() {
    return <FlexDashboard dashboardConfig={getDashboardConfig(dashboardConfig)} dashboardName="mapExternalNetworks" />;
}

export default DashboardMapExternalNetworks;
